import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const socialIcons = [
    <svg key="tg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 0C5.374 0 0 5.373 0 12s5.374 12 12 12 12-5.373 12-12S18.626 0 12 0zm5.568 8.16c-.18 1.897-.962 6.502-1.359 8.627-.168.9-.499 1.201-.82 1.23-.697.064-1.226-.461-1.901-.903-1.056-.692-1.653-1.123-2.678-1.8-1.185-.781-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
    </svg>,
    <svg key="dc" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
    </svg>
  ];

  return (
    <footer className="footer" id="contact">
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <div className="footer-logo">
              <img src="/pathproxy.png" alt="PathProxy Logo" className="footer-logo-image" />
              <span className="brand-name">pathproxy</span>
            </div>
            <p className="footer-description">
              Premium proxy solutions for businesses and individuals. Fast, reliable, and secure proxy services worldwide.
            </p>
            <div className="footer-social">
              <a href="https://t.me/pathproxy" target="_blank" rel="noopener noreferrer" className="social-link">
                {socialIcons[0]}
              </a>
              <a href="https://discord.gg/pathproxy" target="_blank" rel="noopener noreferrer" className="social-link">
                {socialIcons[1]}
              </a>
            </div>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Products</h4>
            <ul className="footer-links">
              <li><a href="/#pricing">Rotating Residential Basic</a></li>
              <li><a href="/#pricing">Rotating Residential Premium</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Pages</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><a href="/#pricing">Pricing</a></li>
              <li><Link to="/locations">Locations</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Support</h4>
            <ul className="footer-links">
              <li><Link to="/help">Help Center</Link></li>
              <li><Link to="/api">API Reference</Link></li>
              <li><Link to="/help">Contact Support</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/terms">Terms & Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/refund">Refund Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <p>&copy; 2026 pathproxy. All rights reserved.</p>
          </div>
          <div className="footer-bottom-right">
            <div className="payment-methods">
              <span className="payment-label">We accept:</span>
              <div className="payment-icons">
                <svg width="32" height="20" viewBox="0 0 32 20" fill="none">
                  <rect width="32" height="20" rx="3" fill="#1A1A1A"/>
                  <text x="16" y="14" textAnchor="middle" fill="#E8FF00" fontSize="8" fontWeight="600">BTC</text>
                </svg>
                <svg width="32" height="20" viewBox="0 0 32 20" fill="none">
                  <rect width="32" height="20" rx="3" fill="#1A1A1A"/>
                  <text x="16" y="14" textAnchor="middle" fill="#E8FF00" fontSize="8" fontWeight="600">ETH</text>
                </svg>
                <svg width="32" height="20" viewBox="0 0 32 20" fill="none">
                  <rect width="32" height="20" rx="3" fill="#1A1A1A"/>
                  <circle cx="10" cy="10" r="5" fill="#EB001B"/>
                  <circle cx="22" cy="10" r="5" fill="#F79E1B"/>
                </svg>
                <svg width="32" height="20" viewBox="0 0 32 20" fill="none">
                  <rect width="32" height="20" rx="3" fill="#1A1A1A"/>
                  <rect x="8" y="8" width="16" height="4" fill="#1434CB"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
